import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";
import { ADMIN_MODULES, MAIN_MODULES } from "@/lib/modules";
import { Logo } from "@/components/common/Logo";
import { SectionLabel } from "@/components/common/ui-kit";
import { NAV } from "@/design/tokens";

const NavItem = ({ item, onNavigate }) => {
  const Icon = item.icon;
  return (
    <NavLink to={item.path} onClick={onNavigate} data-testid={`nav-item-${item.id}`}
      className={({ isActive }) => cn(NAV.item, isActive ? NAV.active : NAV.idle)}>
      {({ isActive }) => (
        <>
          <Icon className={cn("h-[18px] w-[18px] shrink-0", isActive ? NAV.iconActive : NAV.iconIdle)} strokeWidth={1.75} />
          <span className="truncate">{item.label}</span>
          {item.phase && <span className="ml-auto text-[10px] font-medium text-slate-300 group-hover:text-slate-400">F{item.phase}</span>}
        </>
      )}
    </NavLink>
  );
};

export const Sidebar = ({ onNavigate }) => {
  const { can, me } = useAuth();
  const main = MAIN_MODULES.filter((m) => (!m.perm ? !(m.id === "password-manager" && me?.is_demo_user) : can(m.perm)));
  const admin = ADMIN_MODULES.filter((m) => (m.perm === "__platform" ? me?.platform_admin : can(m.perm)) && !me?.is_demo_user);
  return (
    <nav className="flex h-full w-full flex-col" data-testid="sidebar">
      <div className="flex h-16 shrink-0 items-center border-b border-line px-5">
        <Logo />
      </div>
      <div className="flex-1 space-y-6 overflow-y-auto px-3 py-5">
        <div className="space-y-0.5">{main.map((m) => <NavItem key={m.id} item={m} onNavigate={onNavigate} />)}</div>
        {admin.length > 0 && (
          <div data-testid="sidebar-admin-section">
            <SectionLabel className="mb-2 px-3">Amministrazione</SectionLabel>
            <div className="space-y-0.5">{admin.map((m) => <NavItem key={m.id} item={m} onNavigate={onNavigate} />)}</div>
          </div>
        )}
      </div>
      <div className="border-t border-line px-5 py-3 text-[11px] text-slate-400">Fase 5 · Technical Operations</div>
    </nav>
  );
};
